import * as api from "Api";
import * as actions from "Actions";

export const saveSlideComposition = slideId => (dispatch, getState) => {
  const {
    slideComposition: {
      composition: { labels, isPublic, SlideIndicators, layout, isEditable }
    },
    auth: { currentOrganization },
    params: { backOffice }
  } = getState();
  return dispatch(
    actions.saveSlideComposition(
      api.saveSlideComposition({
        uen: currentOrganization.uen,
        slideId,
        labels,
        isPublic: backOffice ? true : isPublic,
        SlideIndicators,
        layout,
        status: backOffice ? "STANDARD" : "CREATED",
        isEditable
      })
    )
  );
};
export const fetchSlide = slideId => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    const { backOffice } = getState().params;
    dispatch(
      actions.fetchSlide(
        api
          .getSlide({
            id: slideId,
            uen: currentOrganization.uen,
            status: backOffice ? "STANDARD" : "CREATED"
          })
          .then(res => {
            return res.data.data;
          })
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/slideComposition.js